import {useState} from "react";
import {dataStorage} from "../../utils/StorageService";
import {initialGridData} from "../../utils/gameUtils/initialGridData";
import {useSizeItem} from "../../provider/ResizeProvider";

export const useGridDataByMode = () => {
    const {itemSize} = useSizeItem();

    const [gridData, setGridData] = useState(dataStorage.getItem()?.grid_data || initialGridData(itemSize));

    return {
        gridData,
        setGridData,
    }
}